import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";

export function ButtonDelete({value, name, onDelete, loading, variant="primary", children}) {

    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = () => {
        if (typeof onDelete === "function")
            onDelete()
        handleClose()
    }

    return <>
        <Button variant={variant} onClick={handleShow} disabled={loading}>
            {children}
        </Button>

        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={true} restoreFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                By clicking <i className="text-danger">I am sure, delete {value}</i> your action cannot be reverted.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="danger" onClick={handleDelete}>I am sure, delete {value}</Button>
            </Modal.Footer>
        </Modal>
    </>
}